var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12, _rect, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14 34h12a2 2 0 0 1 2 2v24a0 0 0 0 1 0 0h-16a0 0 0 0 1 0 0v-24a2 2 0 0 1 2-2z",
    fill: "#fab400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m28 43.586-3.707 3.707a1 1 0 0 0 .707 1.707h3z",
    fill: "#dc9600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m51 16h-22a1 1 0 0 0 -1 1v25.586l-3.707 3.707a1 1 0 0 0 .707 1.707h26a1 1 0 0 0 1-1v-30a1 1 0 0 0 -1-1z",
    fill: "#c80a50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m28 17v12.859a3.992 3.992 0 0 0 3-3.859v-6a2 2 0 0 0 -2-2v-2a1 1 0 0 0 -1 1z",
    fill: "#a00028"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m14 28h12v6.063h-12z",
    fill: "#f0c8a0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m12 20h16a0 0 0 0 1 0 0v8a2 2 0 0 1 -2 2h-10a4 4 0 0 1 -4-4v-6a0 0 0 0 1 0 0z",
    fill: "#d2aa82"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f0c8a0"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 7,
    rx: 2,
    width: 4,
    x: 12,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    height: 8,
    rx: 2,
    width: 4,
    x: 16,
    y: 14
  }), /*#__PURE__*/React.createElement("rect", {
    height: 9,
    rx: 2,
    width: 4,
    x: 20,
    y: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 18v-12a2 2 0 0 0 -4 0v12z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m13 20v-3a2 2 0 0 1 1.5-1.937 2 2 0 0 0 -2.5 1.937v3a2 2 0 0 0 2.5 1.937 2 2 0 0 1 -1.5-1.937z",
    fill: "#d2aa82"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m17 20v-4a2 2 0 0 1 1.5-1.937 2 2 0 0 0 -2.5 1.937v4a2 2 0 0 0 2.5 1.937 2 2 0 0 1 -1.5-1.937z",
    fill: "#d2aa82"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m21 20v-5a2 2 0 0 1 1.5-1.937 2 2 0 0 0 -2.5 1.937v5a2 2 0 0 0 2.5 1.937 2 2 0 0 1 -1.5-1.937z",
    fill: "#d2aa82"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m25 18v-12a2 2 0 0 1 1.5-1.937 2 2 0 0 0 -2.5 1.937v12z",
    fill: "#d2aa82"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m28 18h-5a1.008 1.008 0 0 0 -1 1.024 3 3 0 0 0 3 2.976h1a4 4 0 0 0 -4 4v4h4a4 4 0 0 0 4-4v-6a2 2 0 0 0 -2-2z",
    fill: "#f0c8a0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m26 21a3 3 0 0 1 -3-3 1 1 0 0 0 -1 1 3 3 0 0 0 3 3h3v-1z",
    fill: "#d2aa82"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#f0f0f0",
    height: 18,
    rx: 2,
    width: 4,
    x: 38,
    y: 20
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 42,
    fill: "#f0f0f0",
    r: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.929b6376.svg";
export { ForwardRef as ReactComponent };